document.addEventListener("DOMContentLoaded", () => {
  const headings = document.querySelectorAll(".article-template_it01 h2, .article-template_it01 h3");
  const toc = document.getElementById("toc");
  const tocList = document.getElementById("toc-list");
  const toggleButton = document.getElementById("toc-toggle");

  function updateTocListClass(expanded) {
    tocList.classList.remove("fadeout", "expanded");
    if (expanded) {
      tocList.classList.add("expanded");
    } else {
      tocList.classList.add("fadeout");
    }
  }

  if (headings.length === 0) {
    toc.classList.add("hidden");
  } else {
    toc.classList.remove("hidden");

    let h2Count = 0;
    let h3Count = 0;

    headings.forEach((heading, index) => {
      let numberLabel = "";
      if (heading.tagName === "H2") {
        h2Count++;
        h3Count = 0;
        numberLabel = `${h2Count}`;
      } else if (heading.tagName === "H3") {
        h3Count++;
        numberLabel = `${h2Count}-${h3Count}`;
      }

      const id = `heading-${index + 1}`;
      heading.id = id;

      const listItem = document.createElement("li");
      const link = document.createElement("a");
      link.href = `#${id}`;
      link.textContent = `${numberLabel}. ${heading.textContent}`;

      if (heading.tagName === "H2") {
        listItem.classList.add("toc-h2");
      } else if (heading.tagName === "H3") {
        listItem.classList.add("toc-h3");
      }

      listItem.appendChild(link);
      tocList.appendChild(listItem);

      if (index >= 10) {
        listItem.style.display = "none";
        listItem.classList.add("toc-hidden");
      }
    });

    if (headings.length > 10) {
      toggleButton.style.display = "inline-block";
      let expanded = false;

      updateTocListClass(expanded);

      toggleButton.addEventListener("click", () => {
        const hiddenItems = document.querySelectorAll(".toc-hidden");
        expanded = !expanded;

        hiddenItems.forEach(item => {
          item.style.display = expanded ? "list-item" : "none";
        });

        toggleButton.textContent = expanded ? "閉じる" : "もっと見る";
        updateTocListClass(expanded);
      });
    }

    const firstHeading = headings[0];
    firstHeading.parentNode.insertBefore(toc, firstHeading);
  }
});

// スムーズスクロール
document.querySelectorAll('#toc a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    if (!targetElement) return;

    const offset = 60;
    const elementTop = targetElement.getBoundingClientRect().top;
    const scrollTo = window.pageYOffset + elementTop - offset;

    history.pushState(null, '', `#${targetId}`);
    window.scrollTo({ top: scrollTo, behavior: 'smooth' });
  });
});

//図面の目次
document.addEventListener("DOMContentLoaded", () => {
  const headings = document.querySelectorAll(".zumen h2, .zumen h3, .link_item1");
  const toc = document.getElementById("toc");
  const tocList = document.getElementById("toc-list");
  const toggleButton = document.getElementById("toc-toggle");

  function updateTocListClass(expanded) {
    tocList.classList.remove("fadeout", "expanded");
    if (expanded) {
      tocList.classList.add("expanded");
    } else {
      tocList.classList.add("fadeout");
    }
  }

  if (headings.length === 0) {
    toc.classList.add("hidden");
  } else {
    toc.classList.remove("hidden");

    headings.forEach((heading, index) => {
      const id = `heading-${index + 1}`;
      heading.id = id;

      const listItem = document.createElement("li");
      const link = document.createElement("a");
      link.href = `#${id}`;
      link.textContent = heading.textContent; // ✅ 連番なしで見出しテキストのみ

      if (heading.tagName === "H2") {
        listItem.classList.add("toc-h2");
      } else if (heading.tagName === "H3") {
        listItem.classList.add("toc-h3");
      } else if (heading.classList.contains("link_item1")) {
        listItem.classList.add("toc-link_item1");
      }

      listItem.appendChild(link);
      tocList.appendChild(listItem);

      if (index >= 10) {
        listItem.style.display = "none";
        listItem.classList.add("toc-hidden");
      }
    });

    if (headings.length > 10) {
      toggleButton.style.display = "inline-block";
      let expanded = false;

      updateTocListClass(expanded);

      toggleButton.addEventListener("click", () => {
        const hiddenItems = document.querySelectorAll(".toc-hidden");
        expanded = !expanded;

        hiddenItems.forEach(item => {
          item.style.display = expanded ? "list-item" : "none";
        });

        toggleButton.textContent = expanded ? "閉じる" : "もっと見る";
        updateTocListClass(expanded);
      });
    }

    const firstHeading = headings[0];
    firstHeading.parentNode.insertBefore(toc, firstHeading);

    // スムーズスクロール処理（headingsがある場合のみ）
    document.querySelectorAll('#toc a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;

        const offset = 60;
        const elementTop = targetElement.getBoundingClientRect().top;
        const scrollTo = window.pageYOffset + elementTop - offset;

        history.pushState(null, '', `#${targetId}`);
        window.scrollTo({ top: scrollTo, behavior: 'smooth' });
      });
    });
  }
});

//よくある質問のアコーディオンJS
document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll('.js-acc-item');

  accordionItems.forEach(function (item) {
    const trigger = item.querySelector('.js-acc-single-trigger');

    if (trigger) {
      trigger.addEventListener('click', function () {

        // 現在の項目を開閉
        item.classList.toggle('is-open');
        const content = item.querySelector('.accordion-single-content');
        if (content) {
          if (item.classList.contains('is-open')) {
            content.style.maxHeight = content.scrollHeight + 'px';
          } else {
            content.style.maxHeight = null;
          }
        }
      });
    }
  });
});